<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8" class="mx-auto">
        <v-card flat color="transparent">
          <v-subheader>Set Temperature Colours</v-subheader>
          <v-card-text>
            <v-slider
              v-model="orange"
              color="orange"
              label="Orange from:"
              thumb-label="always"
              :max="this.red"
              :min="min"
            ></v-slider>
            <v-slider
              v-model="red"
              color="red"
              label="Red from:"
              thumb-label="always"
              :max="max"
              :min="this.orange"
            ></v-slider>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined color="#2d3142" :loading="btnLoading" @click="save">
              Save
            </v-btn>
            <v-btn
              outlined
              color="#2d3142"
              :loading="refLoading"
              @click="reset"
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      refLoading: false,
      min: 0,
      max: 50,
    };
  },
  computed: {
    ...mapState({
      btnLoading: (state) => state.btnLoading,
      preferences: (state) => state.auth.preferences,
    }),

    orange: {
      get() {
        return this.preferences.tempInMin;
      },
      set(newValue) {
        this.preferences.tempInMin = newValue;
      },
    },

    red: {
      get() {
        return this.preferences.tempInMax;
      },
      set(newValue) {
        this.preferences.tempInMax = newValue;
      },
    },
  },
  methods: {
    save() {
      const preferences = {
        tempInMin: this.orange,
        tempInMax: this.red,
      };
      this.$store.dispatch("updatePreferences", preferences);
    },

    reset() {
      this.$store.dispatch("fetchPreferences");
    },
  },
};
</script>
